module.exports = __webpack_public_path__ + "static/img/ck_img_append.8ddc8461.png";